import { FilterItem, FilterItemType } from '@otp/ui';
import { UserLevel, UserType } from 'src/graphql/generated/graphql';
import { TFunction } from 'i18next';
import { StoresServerSideField } from 'src/components/common/stores/stores-serverside';
import React from 'react';

export const getFilterConfig = ({ t, size }: { t: TFunction; size: number }) =>
  [
    {
      id: 'firstName',
      size,
      type: FilterItemType.Input,
      props: {
        name: 'firstName',
        placeholder: t('manage-otps.first-name'),
        fullWidth: true,
        label: t('manage-otps.first-name'),
      },
    },
    {
      id: 'lastName',
      size,
      type: FilterItemType.Input,
      props: {
        name: 'lastName',
        placeholder: t('manage-otps.last-name'),
        fullWidth: true,
        label: t('manage-otps.last-name'),
      },
    },
    {
      id: 'email',
      size,
      type: FilterItemType.Input,
      props: {
        name: 'email',
        placeholder: t('manage-otps.email'),
        fullWidth: true,
        label: t('manage-otps.email'),
      },
    },
    {
      id: 'mcId',
      size,
      type: FilterItemType.Input,
      props: {
        name: 'mcId',
        placeholder: t('manage-otps.eid'),
        fullWidth: true,
        label: t('manage-otps.eid'),
      },
    },
    {
      id: 'phone',
      size,
      type: FilterItemType.Input,
      props: {
        name: 'phone',
        placeholder: t('manage-otps.phone'),
        fullWidth: true,
        label: t('manage-otps.phone'),
      },
    },
    {
      id: 'storeId',
      size,
      type: FilterItemType.Custom,
      render: (props) => {
        return <StoresServerSideField {...props}></StoresServerSideField>;
      },
      props: {
        inputProps: {
          placeholder: t('manage-otps.store-number'),
          name: 'storeId',
          fullWidth: true,
          label: t('manage-otps.store-number'),
        },
      },
    },
    {
      id: 'programEnum',
      size,
      type: FilterItemType.Select,
      props: {
        inputProps: {
          placeholder: t('manage-otps.program'),
          variant: 'outlined',
          name: 'programEnum',
          label: t('manage-otps.program'),
        },
        fullWidth: true,
        options: [
          {
            name: 'Otp',
            value: 'otp',
          },
          {
            name: 'Stp',
            value: 'stp',
          },
        ],
      },
    },
    {
      id: 'levels',
      size,
      type: FilterItemType.Multiselect,
      props: {
        multiple: true,
        inputProps: {
          placeholder: t('manage-otps.levels'),
          variant: 'outlined',
          name: 'levels',
          label: t('manage-otps.levels'),
        },
        options: [
          {
            name: 'OTP 0',
            value: UserLevel.Otp0,
          },
          {
            name: 'OTP 1',
            value: UserLevel.Otp1,
          },
          {
            name: 'OTP 2',
            value: UserLevel.Otp2,
          },
          {
            name: 'OTP 3',
            value: UserLevel.Otp3,
          },
          {
            name: 'OTP Elite',
            value: UserLevel.Otp4,
          },
          // {
          //   name: 'STP 0',
          //   value: UserLevel.Stp0,
          // },
          // {
          //   name: 'STP 1',
          //   value: UserLevel.Stp1,
          // },
          // {
          //   name: 'STP 2',
          //   value: UserLevel.Stp2,
          // },
        ],
        fullWidth: true,
      },
    },
    {
      id: 'type',
      size,
      type: FilterItemType.Select,
      props: {
        inputProps: {
          placeholder: t('manage-otps.type'),
          variant: 'outlined',
          name: 'type',
          label: t('manage-otps.type'),
        },
        fullWidth: true,
        options: [
          {
            name: 'OTP',
            value: UserType.Otp,
          },
          {
            name: 'STP',
            value: UserType.Stp,
          },
        ],
      },
    },
    {
      id: 'hasPortalAccess',
      size,
      type: FilterItemType.Select,
      props: {
        inputProps: {
          placeholder: t('manage-otps.has-portal-access'),
          variant: 'outlined',
          name: 'hasPortalAccess',
          label: t('manage-otps.has-portal-access'),
        },
        fullWidth: true,
        options: [
          {
            name: t('manage-otps.has-portal-access-values.true'),
            value: true,
          },
          {
            name: t('manage-otps.has-portal-access-values.false'),
            value: false,
          },
        ],
      },
    },
  ] as FilterItem[];
